import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

const VALID_LANGS = ['fr', 'en', 'ar'];

export function LanguageProvider({ children }) {
  // Force clear any old cached value and start fresh with fr
  const saved = localStorage.getItem('cafepos_lang');
  const initial = VALID_LANGS.includes(saved) ? saved : 'fr';

  const [lang, setLang] = useState(initial);

  function toggleLang() {
    const current = VALID_LANGS.indexOf(lang);
    const next = VALID_LANGS[(current + 1) % VALID_LANGS.length];
    localStorage.setItem('cafepos_lang', next);
    setLang(next);
  }

  return (
    <LanguageContext.Provider value={{ lang, toggleLang }}>
      <div dir={lang === 'ar' ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}